"use client";
import { Flex } from "@radix-ui/themes";

import { CreateClient } from "@/app/actions/clients/actions";
import FileInput from "@/components/form/FileInput";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AlertTriangle } from "lucide-react";
import { useRouter } from "next/navigation";
import { useActionState, useEffect, useRef } from "react";

type StateType = {
  error?: string | undefined;
};

export default function Create() {
  const router = useRouter();

  const inputFileRef = useRef<HTMLInputElement>(null);

  const [formState, formAction, formIsPending] = useActionState(
    async (_previousState: any, formData: FormData): Promise<StateType> => {
      const firstName = formData.get("contacFirstName") as string;
      const lastName = formData.get("contactLastName") as string;
      const email = formData.get("contactEmail") as string;
      const phone = formData.get("contactPhone") as string;

      const name = formData.get("name") as string;

      let logo: File | undefined;

      if (
        inputFileRef.current !== null &&
        inputFileRef.current?.files !== null
      ) {
        if (inputFileRef.current.files.length > 0) {
          logo = inputFileRef.current.files[0];
        }
      }

      const { id, error } = await CreateClient({
        name,
        logo,
        primary_contact: {
          firstName,
          lastName,
          email,
          phone,
        },
      });

      if (error || !id) {
        return {
          error: error || "Failed to create client",
        };
      }

      router.push(`/clients/${id}`);
      return {};
    },
    null,
  );

  useEffect(() => {
    console.log("inputFileRef", inputFileRef);
  }, [inputFileRef]);

  return (
    <Flex gap="3" direction="column" className="w-full max-w-3xl">
      <form action={formAction}>
        <Card>
          <CardHeader>
            <CardTitle>Create a Client</CardTitle>
            <CardDescription>
              Create a client to manage your timesheets and contracts
            </CardDescription>
          </CardHeader>
          <CardContent>
            {formState?.error && (
              <Alert variant="destructive" className="mb-4 mt-4">
                <AlertTriangle className="h-6 w-6" />
                <AlertTitle className="!pl-8">Error</AlertTitle>
                <AlertDescription className="!pl-8">
                  {formState.error}
                </AlertDescription>
              </Alert>
            )}
            <Flex direction="column" gap="4">
              <Flex direction="column" gap="2">
                <Label htmlFor="name">Client Name</Label>
                <Input placeholder="Client Name" name="name" />
              </Flex>
              <Flex direction="column" gap="2">
                <Label htmlFor="logo">Logo</Label>
                <FileInput
                  label="Upload a logo"
                  name="logo"
                  ref={inputFileRef}
                  accept="image/png, image/jpeg, image/svg+xml"
                ></FileInput>
              </Flex>
              <Flex direction="column" gap="2">
                <Label htmlFor="primaryContact">Primary Contact</Label>
                <Flex gap="2">
                  <Input placeholder="First Name" name="contacFirstName" />
                  <Input placeholder="Last Name" name="contactLastName" />
                </Flex>
                <Flex gap="2">
                  <Input placeholder="Email" name="contactEmail" />
                  <Input placeholder="Phone" name="contactPhone" />
                </Flex>
              </Flex>
            </Flex>
          </CardContent>
          <CardFooter>
            <Button type="submit" disabled={formIsPending}>
              Create Client
            </Button>
          </CardFooter>
        </Card>
      </form>
    </Flex>
  );
}
